import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';

abstract class HubBase {
  // @ts-expect-error added by automation
  public connection: signalR.HubConnection;
  protected transformedUrl: string;

  protected constructor(
    endpoint: string,
    params?: object,
    transport: HttpTransportType = HttpTransportType.WebSockets
  ) {
    this.transformedUrl = endpoint;
    this.initializeConnection(transport);
  }

  public stopConnection = async () => {
    await this.connection.stop();
  };

  protected startConnection = async () => {
    await this.connection.start();
  };

  private initializeConnection = (transport: HttpTransportType = HttpTransportType.WebSockets) => {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.transformedUrl, {
        transport: transport,
        withCredentials: true
      })
      .withAutomaticReconnect([0, 2000, 10000, 30000, 60000])
      .withKeepAliveInterval(1000)
      .withServerTimeout(90000)
      .build();
  };
}

export default HubBase;
